import { render } from "./RetailerListTable.vue?vue&type=template&id=3b8a94c6&scoped=true"
import script from "./RetailerListTable.vue?vue&type=script&lang=js"
export * from "./RetailerListTable.vue?vue&type=script&lang=js"

import "./RetailerListTable.vue?vue&type=style&index=0&id=3b8a94c6&scoped=true&lang=css"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8a94c6"]])

export default __exports__